import * as z from 'zod';
import { Participant } from './participant';
import { ChallengeStory } from './Story';
import { EmptyObject } from './general';

export const ChallengeTypeEnum = z.enum(['valueBased', 'dailyTaskBased', 'contentBased', 'percentBased', 'personalValueBased']);
export type ChallengeTypeEnum = z.infer<typeof ChallengeTypeEnum>;
export const MessageHour = z.string();
export const MessageTemplate = z.string();

export const WhatsappMessage = z.object({
  messageTemplate: MessageTemplate,
  date: z.string(),
  hour: MessageHour,
});

export const ValueBasedChallengeParams = z.object({
  amount: z.number(),
  expenseCategory: z.string(),
  joinCta: z.string().optional(),
});

export const PercentBasedChallengeParams = z.object({
  percent: z.number(),
  expenseCategory: z.string(),
  joinCta: z.string().optional(),
});

export const PersonalGoaChallengeParams = z.object({
  amount: z.number().optional(),
  expenseCategory: z.string(),
  joinCta: z.string().optional(),
});

export const ContentBasedChallengeParams = z.object({
  joinCta: z.string().optional(),
});

export const ChallengeId = z.string();
export type ChallengeId = z.infer<typeof ChallengeId>;

export const Challenge = z.object({
  challengeId: z.string(),
  name: z.string(),
  startDate: z.string().transform(d => new Date(d)),
  endDate: z.string().transform(d => new Date(d)),
  shortDescription: z.string().optional(),
  description: z.string().optional(),
  whatsappMessages: WhatsappMessage.array(),
  fromTemplate: z.string().optional(),
  type: ChallengeTypeEnum,
  participants: Participant.array(),
  challengeParams: z.union([
    ValueBasedChallengeParams,
    PercentBasedChallengeParams,
    PersonalGoaChallengeParams,
    ContentBasedChallengeParams,
  ]),
  stories: ChallengeStory.array().optional(),
});
export type Challenge = z.infer<typeof Challenge>;

export const RestrictedChallenge = Challenge.omit({ participants: true });
export type RestrictedChallenge = z.infer<typeof RestrictedChallenge>;
